import styled from 'styled-components'

export const ReadonlyTimeWindowContainer = styled.div`
  > * + * {
    margin-top: 6px;
  }
`

ReadonlyTimeWindowContainer.displayName = 'ReadonlyTimeWindowContainer'
